import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { api, adminHeaders } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const ImageUrlField = ({ value, onChange, testId = "product-image-input" }) => {
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const res = await api.post("/admin/images", form, adminHeaders());
      onChange(res.data.url);
      toast.success("Photo uploaded.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed.");
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="mt-1.5 flex items-start gap-3">
      {value ? (
        <img src={value} alt="" data-testid={`${testId}-preview`} className="h-16 w-24 flex-shrink-0 rounded-md border border-border object-cover" />
      ) : (
        <div className="flex h-16 w-24 flex-shrink-0 items-center justify-center rounded-md border border-dashed border-border text-[10px] uppercase tracking-wider text-muted-foreground">
          No photo
        </div>
      )}
      <div className="flex-1 space-y-2">
        <Input data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} placeholder="https://… or upload a photo" />
        <Button type="button" variant="outline" size="sm" data-testid={`${testId}-upload-button`} disabled={busy} onClick={() => fileRef.current?.click()} className="font-bold">
          {busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Upload size={14} className="mr-1.5" />}
          {busy ? "Uploading…" : "Upload photo"}
        </Button>
        <input ref={fileRef} type="file" accept="image/*" data-testid={`${testId}-file`} className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
      </div>
    </div>
  );
};
